import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { AssignmentPatient } from '@interfaces/assignment/assignment-patient';
import { StaffKey } from '@interfaces/assignment/staff-key';

interface AssignmentState {
  patients: AssignmentPatient[];
  staffKey: StaffKey[];
  redirectToDashboard: boolean;
  selectedShiftId: string;
  selectedPatientId: string;
}

export const initialValue: AssignmentState = {
  patients: [],
  staffKey: [],
  redirectToDashboard: false,
  selectedShiftId: '',
  selectedPatientId: '',
};

export const AssignmentStore = signalStore(
  { providedIn: 'root' },
  withState(initialValue),
  withMethods(({ ...store }) => ({
    setAssignments: (data: {
      patients: AssignmentPatient[];
      staffKey: StaffKey[];
    }) => {
      patchState(store, {
        patients: data.patients,
        staffKey: data.staffKey,
      });
    },
    setRedirectToDashboard: (redirect: boolean) => {
      patchState(store, {
        redirectToDashboard: redirect,
      });
    },
    setSelectedShiftId: (id: string) => {
      patchState(store, {
        selectedShiftId: id,
      });
    },
    setSelectedPatientId: (id: string) => {
      patchState(store, {
        selectedPatientId: id,
      });
    },
  })),
);
